'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconHome = function IconHome(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M17.6750788,18.0378333 L13.4104121,18.0378333 C13.0417455,18.0378333 12.7437455,17.7391667 12.7437455,17.3711667 L12.7437455,13.1685 L10.6070788,13.1685 L10.6070788,17.3711667 C10.6070788,17.7391667 10.3090788,18.0378333 9.94041214,18.0378333 L5.67641214,18.0378333 C5.30774547,18.0378333 5.00974547,17.7391667 5.00974547,17.3711667 L5.00974547,10.4465 C5.00974547,10.0785 5.30774547,9.77983333 5.67641214,9.77983333 C6.04441214,9.77983333 6.3430788,10.0785 6.3430788,10.4465 L6.3430788,16.7045 L9.27374547,16.7045 L9.27374547,12.5018333 C9.27374547,12.1338333 9.57174547,11.8351667 9.94041214,11.8351667 L13.4104121,11.8351667 C13.7790788,11.8351667 14.0770788,12.1338333 14.0770788,12.5018333 L14.0770788,16.7045 L17.0084121,16.7045 L17.0084121,10.4465 C17.0084121,10.0785 17.3064121,9.77983333 17.6750788,9.77983333 C18.0430788,9.77983333 18.3417455,10.0785 18.3417455,10.4465 L18.3417455,17.3711667 C18.3417455,17.7391667 18.0430788,18.0378333 17.6750788,18.0378333' }),
      ' ',
      _react2.default.createElement('path', { d: 'M19.6837455,12.0685 C19.5497455,12.0685 19.4144121,12.0285 19.2970788,11.9438333 L11.6764121,6.4865 L4.0550788,11.9438333 C3.7570788,12.1585 3.3390788,12.0891667 3.12374547,11.7898333 C2.91041214,11.4905 2.97974547,11.0738333 3.2790788,10.8598333 L11.2884121,5.1245 C11.5197455,4.9585 11.8324121,4.9585 12.0644121,5.1245 L20.0730788,10.8598333 C20.3730788,11.0738333 20.4417455,11.4905 20.2270788,11.7898333 C20.0970788,11.9718333 19.8924121,12.0685 19.6837455,12.0685' }),
      ' '
    )
  );
};

IconHome.propTypes = {
  color: _propTypes2.default.string
};

IconHome.defaultProps = {
  color: _colors2.default.icons
};

IconHome.displayName = 'IconHome';

exports.default = IconHome;
module.exports = exports.default;